import React from "react";
import Preloader from "../../Global/Preloader";
import Headertwo from "../../Global/Headertwo";
import Portfolio from "../MenPortfolio/Portfolio";
import Ctaone from "../../Global/Ctaone";
import Footer from "../../Global/Footer";
import Portfoliobred from "../../Global/Portfoliobred";
import BackToTop from '../../Global/BackToTop';

const Main =()=>{
    return(
        <>
        {/* <Preloader/> */}
         <Headertwo/>
         <Portfoliobred Title="Why Choose Us" Subtitle="Portfolio"/>
         <Portfolio/>
         {/* <Ctaone/> */}
         <Footer/>
         <BackToTop/>
        </>
    )
}
export default Main;